import { createBrowserHistory } from "history";
export let history = createBrowserHistory({ basename: process.env.PUBLIC_URL});
